import axios from "axios";
const loginOTP = axios.create({
  baseURL: process.env.REACT_APP_LOGINURL,
  headers: {},
});

loginOTP.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const request = {
  get: (url, params) =>
    loginOTP
      .get(url, { params })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err.response.data)),
};
//1->API
export const loginWIthOTP = (params) => request.get("/login", params);
